import { IconProps } from '.';

const LayoutIcon = ({ color, customClasses, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 40 40"
      fill="none"
      className={customClasses}
      {...rest}
    >
      <g clipPath="url(#clip0_18177_142904)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.416992 1.66675C0.416992 0.976392 0.976636 0.416748 1.66699 0.416748H28.3337C29.024 0.416748 29.5837 0.976392 29.5837 1.66675V28.3334C29.5837 29.0238 29.024 29.5834 28.3337 29.5834H1.66699C0.976636 29.5834 0.416992 29.0238 0.416992 28.3334V1.66675ZM2.91699 2.91675V27.0834H13.7503V2.91675H2.91699ZM27.0837 27.0834H16.2503V16.2501H27.0837V27.0834ZM27.0837 13.7501H16.2503V2.91675H27.0837V13.7501Z"
          fill={color || 'var(--color-ui-icon-primary)'}
        />
      </g>
      <defs>
        <clipPath id="clip0_18177_142904">
          <rect
            width="40"
            height="40"
            fill={color || 'var(--color-ui-icon-primary)'}
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default LayoutIcon;
